"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.baseComparator = exports.useUpdateLocalForm = void 0;
const react_1 = require("react");
const useUpdateLocalForm = (getValues, newValue, setValue, scheme, comparator) => {
    const [fields, setFields] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        setFields(Object.keys(scheme.describe().fields));
    }, [scheme]);
    (0, react_1.useEffect)(() => {
        if (newValue) {
            fields.forEach((field) => {
                if (!isEqual(getValues()[field], newValue[field], field, comparator)) {
                    setValue(field, newValue[field]);
                }
            });
        }
    }, [newValue, fields, comparator]);
};
exports.useUpdateLocalForm = useUpdateLocalForm;
const baseComparator = (a, b) => {
    if ((a === null || a === void 0 ? void 0 : a.constructor) == Date && (b === null || b === void 0 ? void 0 : b.constructor) == Date) {
        return a.getTime() == b.getTime();
    }
    return a == b;
};
exports.baseComparator = baseComparator;
const isEqual = (a, b, field, comparator) => {
    if (comparator)
        return comparator(a, b, field);
    return (0, exports.baseComparator)(a, b);
};
